import { render, staticRenderFns } from "./author-assign-course.html?vue&type=template&id=47444ad8&scoped=true&"
import script from "./author-assign-course.js?vue&type=script&lang=js&"
export * from "./author-assign-course.js?vue&type=script&lang=js&"
import style0 from "./author-assign-course.scss?vue&type=style&index=0&id=47444ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47444ad8",
  null
  
)

export default component.exports